var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecipeBuilder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.54 20.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#212121;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.24,20.48H.8a.8.8,0,0,1-.6-1.33l1-1.09A3.15,3.15,0,0,0,2,15.93V3.3A3.3,3.3,0,0,1,5.3,0H18.74a.8.8,0,0,1,.73.47.78.78,0,0,1-.13.85l-1,1.18a3.25,3.25,0,0,0-.78,2.1V17.18A3.3,3.3,0,0,1,14.24,20.48ZM2.58,18.88H14.24a1.7,1.7,0,0,0,1.7-1.7V4.6a4.81,4.81,0,0,1,1-3H5.3A1.7,1.7,0,0,0,3.6,3.3V15.93A4.78,4.78,0,0,1,2.58,18.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.3,5.59H7.24a.8.8,0,1,1,0-1.6H12.3a.8.8,0,0,1,0,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,10.78H10.45a.8.8,0,0,1,0-1.6H13a.8.8,0,1,1,0,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,15.72H10.45a.8.8,0,0,1,0-1.6H13a.8.8,0,0,1,0,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.41,11.3a.75.75,0,0,1-.48-.19l-.68-.63a.7.7,0,0,1,0-1,.71.71,0,0,1,1,0l.16.16.69-.73a.71.71,0,0,1,1,0,.7.7,0,0,1,0,1L6.92,11.08A.74.74,0,0,1,6.41,11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.41,16.24a.7.7,0,0,1-.48-.19l-.68-.63a.7.7,0,1,1,1-1l.16.15.69-.73a.71.71,0,0,1,1,0,.7.7,0,0,1,0,1L6.92,16A.7.7,0,0,1,6.41,16.24Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeBuilder);
export default __webpack_public_path__ + "static/media/RecipeBuilder.4c0a027998ce98c067b623a113138c3d.svg";
export { ForwardRef as ReactComponent };